import { chakra } from "@chakra-ui/react";
import { richTextBlockFactory } from "../richText";
import { ImageCaptionFactory } from "../imageCaptionComponent";
import { ColumnLayout } from "../columnLayout/ColumnLayout";
import { cardGridFactory } from "../cardGrid";

export function getFundsContentBlock(blockData: ContentBlock, index: number) {
  let blockFactory;
  switch (blockData?.content?.contentType) {
    case "richTextEditorComponent":
      blockFactory = richTextBlockFactory(blockData, index, {
        fundsDetailPage: true,
      });
      break;
    case "mediaRatioComponent":
      blockFactory = ImageCaptionFactory(blockData, index);
      break;
    case 'cardGridBlockFund':
      blockFactory = cardGridFactory(blockData, index);
      break;
    case "mediaFullwidthComponent":
      blockFactory = ImageCaptionFactory(blockData, index, {
        isFullWidth: true,
      });
      break;
    case "drieKolom335335335":
    case "tweeKolom5050Layout":
      blockFactory = ColumnLayout(blockData, index);
      break;
    default:
      return null;
  }

  return blockFactory;
}

export default chakra(FundsContentBlocks);
function FundsContentBlocks({ blocksData }: { blocksData: ContentBlock[] }) {
  return (
    <>
      {blocksData.map((element, index) => {
        return getFundsContentBlock(element, index);
      })}
    </>
  );
}
